/**
 * The one spacing scale.
 *
 * This exists so spacing is a *decision made once* rather than a number typed
 * per element. Everything built on it sits on a 4px grid and uses one of the
 * steps below; nothing invents its own margin. That single constraint is most
 * of what separates a considered internal tool from a pile of cards.
 *
 * It started life inside the Reports screens and moved here when `PageHeader`
 * became app-wide — the scale is not a property of Reports, and two copies of
 * it would have drifted the moment one page wanted a 20.
 */
export const space = {
  /** Between a label and the thing it labels. */
  hair: 4,
  /** Within a control group. */
  tight: 8,
  /** Between related rows. */
  snug: 12,
  /** The default gutter, and a panel's inner padding. */
  base: 16,
  /** Between panels. */
  wide: 24,
  /** Between major bands of the page. */
  band: 32,
} as const;
